import styled from 'styled-components/native'
import { SecondaryButton } from 'APP/Components/Buttons'

export const UploadButton = styled(SecondaryButton)`
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
`

export const OldContainer = styled.View`
  gap: ${({ theme }) => theme.metrics.baseMargin}px;
  text-align: right;
  padding-top: 2rem;
  display: flex;
  flex-grow: 1;
`

export const Container = styled.View`
  gap: ${({ theme }) => theme.metrics.baseMargin}px;
  text-align: right;
  padding-top: 2rem;
  display: flex;
  flex-grow: 1;
  padding-left: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
  padding-right: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
`

export const FileInputContainer = styled.View`
  flex-grow: 1;
`

export const ButtonContainer = styled.View`
  display: flex;
  flex-direction: row-reverse;
  gap: ${({ theme }) => theme.metrics.baseMargin}px;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin * 4}px;
  align-items: flex-end;
`
